import React, { useEffect, useState } from "react";
import API from "../services/api";
import ProductCard from "../components/ProductCard";

const ShopPage = () => {
  const [products, setProducts] = useState([]);

  // Fetch products
  const fetchProducts = async () => {
    try {
      const res = await API.get("/selfstore/all");
      setProducts(Array.isArray(res.data.data) ? res.data.data : []);
    } catch (err) {
      console.error("Fetch error:", err);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const handleEdit = async (productId, updatedData) => {
    try {
      await API.put(`/selfstore/edit/${productId}`, updatedData);
      alert("Product updated successfully!");
      fetchProducts();
    } catch (err) {
      console.error("Update failed:", err);
      alert("Failed to update product");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this product?")) return;

    try {
      await API.delete(`/selfstore/delete/${id}`);
      alert("Deleted!");
      fetchProducts();
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete");
    }
  };

  return (
    <>

      {/* original layout kept for reference
      <div style={{ padding: "20px" }}>
        <h1>Store Products</h1>

        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            justifyContent: "center",
            gap: "20px",
          }}
        >
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}
        </div>
      </div>
      */}

      {/* fixed/updated by ChatGPT on 2025-11-24 22:40:00 –
          /shop now uses a proper responsive grid (2–3 cards per row)
          and aligns perfectly to the sidebar using .content-wrapper */}
      <div
        className="content-wrapper"
        style={{ padding: "20px 20px 20px 32px" }}
      >
        <h1 style={{ marginBottom: "20px" }}>     Products</h1>

        <div
          style={{
            display: "grid",
            gap: "20px",
            gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
            // This ensures:
            // - 3 columns on large desktop
            // - 2 columns on medium screens
            // - 1 column on mobile
            alignItems: "start",
          }}
        >
          {products.map((product) => (
            <ProductCard
              key={product._id}
              product={product}
              onEdit={handleEdit}
              onDelete={handleDelete}
            />
          ))}

          {products.length === 0 && (
            <p style={{ marginTop: "8px", color: "#666" }}>
              No products found in your shop.
            </p>
          )}
        </div>
      </div>
    </>
  );
};

export default ShopPage;
